import React from 'react'

export const TituloComponent = ({titulo}) => {
  return (
    <div
        style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        maxWidth:700
        }}
    >

        <span
            style={{
            fontSize:40,
            fontWeight:'bold'
            }}
            >
            {titulo}
        </span>
        <span
        style={{
            display:'flex',
            flexDirection:'row',
            alignItems:'center'
        }}
        >

        </span>
    </div>
  )
}
